import { Controller } from "@hotwired/stimulus";

// Keeps the selected chip visible in the Saved tab's Creator List rail.
//
// At phone width the rail is a single horizontally-scrolling row, so a list
// sitting past the fold would leave the roster looking unfiltered — you'd see
// "6 creators" with no visible indication of which list you were in.
export default class extends Controller {
  static targets = ["scroller"];

  connect() {
    this.revealActive();
  }

  revealActive() {
    if (!this.hasScrollerTarget) return;
    const active = this.scrollerTarget.querySelector(".is-active");
    if (!active) return;

    const scroller = this.scrollerTarget;
    if (scroller.scrollWidth <= scroller.clientWidth) return;

    // scrollIntoView would also scroll the page vertically on load.
    const offset =
      active.offsetLeft - (scroller.clientWidth - active.offsetWidth) / 2;
    scroller.scrollLeft = Math.max(0, offset);
  }
}
